import * as React from 'react';
import { Button } from './button';

interface Props {
  customSelected: boolean;
  selectedBid: number;
  recommendationAmount: number;
  recommendationPercents: number[];
  onClick: (value) => void;
}

export function ButtonGroup(props: Props) {
  const valueToHighlight = props.selectedBid || (props.recommendationAmount / 100);

  return (
    <>
      {props.recommendationPercents.map((percent) => {
        const value = percent / 100;
        const selected = !props.customSelected && value === valueToHighlight;

        return (
          <Button
            text={`${percent}%`}
            value={value}
            key={percent}
            selected={selected}
            onClick={props.onClick}
          />
        );
      })}
    </>
  );
}



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/components/bump/button_group.tsx